import {
  EnvironmentProviders,
  InjectionToken,
  makeEnvironmentProviders,
} from '@angular/core';
import { provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import {
  HOMI_SETTINGS_FEATURE_KEY,
  homiSettingsReducer,
} from './+state/homi-settings/homi-settings.reducer';
import { HomiSettingsEffects } from './+state/homi-settings/homi-settings.effects';

export interface HomiSettingsConfig {
  homiApiUrl: string;
  eloRedirectUri?: string;
}

export const HOMI_SETTINGS_CONFIG: InjectionToken<HomiSettingsConfig> =
  new InjectionToken<HomiSettingsConfig>('HOMI_SETTINGS_CONFIG');

export function provideHomiSettings(
  config: HomiSettingsConfig,
): EnvironmentProviders {
  return makeEnvironmentProviders([
    { provide: HOMI_SETTINGS_CONFIG, useValue: config },
    provideState(HOMI_SETTINGS_FEATURE_KEY, homiSettingsReducer),
    provideEffects(HomiSettingsEffects),
  ]);
}
